/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { contest } from '../models/contest';
import type { contest_dto } from '../models/contest_dto';
import type { team } from '../models/team';
import type { team_dto } from '../models/team_dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TournamentService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get contests
   * @returns contest successful
   * @throws ApiError
   */
  public getContests({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<contest>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/tournament/contests',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get contest
   * @returns contest successful
   * @throws ApiError
   */
  public getContest({
    id,
    locale,
  }: {
    /**
     * Contest identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<contest> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/tournament/contests/{id}',
      path: {
        id: id,
        locale: locale,
      },
    });
  }
  /**
   * Get My Contests
   * @returns contest successful
   * @throws ApiError
   */
  public getMyContests({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<contest>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/tournament/my_contests',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Create my Contest
   * @returns contest successful
   * @throws ApiError
   */
  public createMyContest({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: contest_dto;
  }): CancelablePromise<contest> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/tournament/my_contests',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get my Contest
   * @returns contest successful
   * @throws ApiError
   */
  public getMyContest({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Contest identifier
     */
    id: string;
  }): CancelablePromise<contest> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/tournament/my_contests/{id}',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Update My Contest
   * @returns contest successful
   * @throws ApiError
   */
  public updateMyContest({
    locale,
    id,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Contest identifier
     */
    id: string;
    requestBody?: contest_dto;
  }): CancelablePromise<contest> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/tournament/my_contests/{id}',
      path: {
        locale: locale,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete My Contest
   * @returns void
   * @throws ApiError
   */
  public deleteMyContest({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Contest identifier
     */
    id: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/{locale}/api/v1/tournament/my_contests/{id}',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Get my teams
   * @returns team successful
   * @throws ApiError
   */
  public getMyTeams({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<team>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/tournament/my_teams',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Create my team
   * @returns team successful
   * @throws ApiError
   */
  public createMyTeam({
    locale,
    id,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Contest identifier
     */
    id: string;
    requestBody?: team_dto;
  }): CancelablePromise<team> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/tournament/contests/{id}/my_teams',
      path: {
        locale: locale,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get my team
   * @returns team successful
   * @throws ApiError
   */
  public getMyTeam({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Team identifier
     */
    id: number;
  }): CancelablePromise<team> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/tournament/my_teams/{id}',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Update my team
   * @returns team successful
   * @throws ApiError
   */
  public updateMyTeam({
    locale,
    id,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Team identifier
     */
    id: number;
    requestBody?: team_dto;
  }): CancelablePromise<team> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/tournament/my_teams/{id}',
      path: {
        locale: locale,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
